module.exports = __webpack_public_path__ + "img/no_goods.6b09302a.png";